import { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { getUserAuth } from "data/actions/userAuthActions";
import { useCurrentUID } from "components/hooks/useCurrentUID";
import { useSlice } from "components/hooks/useSlice";

export function RequireSuperuser({ children }) {
  const dispatch = useDispatch();
  const uid = useCurrentUID();

  useEffect(() => {
    if (uid) {
      dispatch(getUserAuth(uid));
    }
  }, [dispatch, uid]);

  const isSuperUser = useSlice("users", (users) => {
    return users[uid]?.userAuth?.is_superuser;
  });

  if (isSuperUser) {
    return children;
  }

  return null;
}

RequireSuperuser.propTypes = {
  children: PropTypes.node,
};

export default RequireSuperuser;
